import { useDealPromptDomainsContext } from '../utils/context/DealPromptDomainsContext';

export const useAudienceExcelGenerate = () => {
  const { useDealPromptAudienceExcelGenerate } = useDealPromptDomainsContext();

  const { fetchDealPromptAudienceExcelGenerate } = useDealPromptAudienceExcelGenerate();

  return fetchDealPromptAudienceExcelGenerate;
};
